import React, { useEffect, useState } from "react";
import {
  getImageFromIndexedDB,
  saveImageToIndexedDB,
} from "../utils/indexedDb";
import defaultProfilePic from "../assets/defaultProfilePic.png";

// Replace with actual AWS fetch function
const fetchImageFromS3 = async (foodItemId) => {
  // console.log("CALLING AWS FOR : " + memberId);
  const res = await fetch(
    `https://zpotterfood.s3.ap-south-1.amazonaws.com/${foodItemId.substring(
      0,
      11
    )}/${foodItemId.substring(11)}?v=${Date.now()}`
    // { mode: "no-cors" }
  ); // Proxy through backend
  if (res.status === 404) return 404;
  const blob = await res.blob();
  return blob;
};

const MemberImage = ({
  foodItemId,
  currentlySelling,
  imageUpdatedTimeFromDB,
  photoUploaded,
  width = "3.5rem",
  height = "3.5rem",
}) => {
  // console.log("inside MemberImage");
  // console.log(memberId);
  // console.log("scrolling MemberImage : " + memberId);
  const [imageURL, setImageURL] = useState(null);

  useEffect(() => {
    const loadImage = async () => {
      if (!foodItemId) return;
      const cached = await getImageFromIndexedDB(foodItemId);

      if (
        !cached ||
        cached.updatedTime < imageUpdatedTimeFromDB // Compare with DB time
      ) {
        // console.log("image NOT available in indexed DB : " + memberId);
        if (currentlySelling) {
          if (photoUploaded || photoUploaded === undefined) {
            const newImageBlob = await fetchImageFromS3(foodItemId);
            if (newImageBlob === 404) {
              await saveImageToIndexedDB(foodItemId, 404, new Date().getTime());
              setImageURL(null);
            } else {
              await saveImageToIndexedDB(
                foodItemId,
                newImageBlob,
                imageUpdatedTimeFromDB
              );
              const url = URL.createObjectURL(newImageBlob);
              setImageURL(url);
            }
          } else
            console.log(
              `condition not satisfied "photoUploaded || photoUploaded === undefined"`
            );
        } else {
          console.log("validity expired a month ago : " + foodItemId);
        }
      } else {
        // console.log("image available in indexed DB : " + memberId);
        if (cached.imageBlob === 404) setImageURL(null);
        else {
          const url = URL.createObjectURL(cached.imageBlob);
          setImageURL(url);
        }
      }
    };

    loadImage();
  }, [foodItemId]);

  return imageURL ? (
    <img
      src={imageURL}
      alt="foodImage"
      style={{ width: width, height: height, borderRadius: "10px" }}
    />
  ) : (
    <img
      src={defaultProfilePic}
      alt="foodImage"
      style={{ width: width, height: height, borderRadius: "10px" }}
    />
  );
};

export default MemberImage;
